export default "__VITE_ASSET__LP_ON311__"